import React from 'react';
import InfoIcon from '@bufferapp/ui/Icon/Icons/Info';

import * as Styled from './styles';

/**
 *
 */
const Message = ({
  colored,
  text,
  url,
}: {
  colored: boolean;
  text: string;
  url: string;
}) => (
  <Styled.Wrapper colored={colored}>
    <Styled.Column>
      <InfoIcon />
    </Styled.Column>
    <Styled.Column>
      <p>{text}</p>
      <a href={url} target="_blank" rel="noopener noreferrer">
        Learn more
      </a>
    </Styled.Column>
  </Styled.Wrapper>
);

export { Message };
